export default function TrashIcon({ width = "15px", stroke }) {
  return (
    <svg
      width={width}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 4.49996H3.16667M3.16667 4.49996H16.5M3.16667 4.49996V16.1666C3.16667 16.6087 3.34226 17.0326 3.65482 17.3451C3.96738 17.6577 4.39131 17.8333 4.83333 17.8333H13.1667C13.6087 17.8333 14.0326 17.6577 14.3452 17.3451C14.6577 17.0326 14.8333 16.6087 14.8333 16.1666V4.49996H3.16667ZM5.66667 4.49996V2.83329C5.66667 2.39127 5.84226 1.96734 6.15482 1.65478C6.46738 1.34222 6.89131 1.16663 7.33333 1.16663H10.6667C11.1087 1.16663 11.5326 1.34222 11.8452 1.65478C12.1577 1.96734 12.3333 2.39127 12.3333 2.83329V4.49996"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
